<template>
  <div class="container">
    <div class="content flex">
      <a-select mode="tags" class="search-input"  v-model="keyWord"  :token-separators="[',', ' ']" @change="getList">
      </a-select>
      <a-button type="primary" class="search-btn">搜索</a-button>
    </div>
    <div class="table-div">
      <a-table class="table" :loading="loading" :columns="columns" :data-source="data" :pagination="false">
        <template v-slot:director="text, record">
          <hide :text="text" @change="clickItem(record)"></hide>
          
        </template> 
      </a-table>
      <div class="xvqiu">
        <a-button type="primary" ghost @click="demandVisible = true">{{ clickSearch ? '搜索结果不满意,' : '' }}点我发布个性找人需求</a-button>
      </div>
      <div><a-button type="link" @click="feedbackVisible = true" class="feedback-button">使用体验不佳， 点我反馈优化流程体验</a-button></div>
    </div>
    <create-demand v-model="demandVisible"></create-demand>

    <feedback v-model="feedbackVisible" type="humit"></feedback>
  </div>
</template>

<script lang="js">
import Vue from 'vue';
import request from '@/assets/js/http';
import Feedback from '@/components/base/feedback.vue';
import Hide from './components/hide.vue';
import CreateDemand from './components/createDemand.vue';
import { queryByName } from '@/api/humint.js';

const columns = [
  {
    title: '姓名',
    dataIndex: 'name',
    key: 'name'
  },
  {
    title: '简介',
    dataIndex: 'info',
    key: 'info'
  },
  {
    title: '负责人',
    dataIndex: 'director',
    key: 'director',
    scopedSlots: {
      customRender: 'director'
    }

  },
  {
    title: '来源',
    dataIndex: 'source',
    key: 'source'
  },
  {
    title: '数据源',
    dataIndex: 'origin',
    key: 'origin'

  }
];

export default Vue.extend({
  name: 'KPSearch',
  components: {
    Feedback,
    CreateDemand,
    Hide,
  },
  data() {
    return {
      columns: columns,
      data: [],
      keyWord: undefined,
      clickSearch: false,
      loading: false,
      demandVisible: false,
      feedbackVisible: false
    };
  },
  methods: {
    async getList() {
      if(this.loading) {
        return;
      }
      this.keyWord = this.keyWord || [];
      let event = {
        message: 'humint搜索',

        type: 'humint-search',
        tags: {
          type: 'humint-search',
          search: this.keyWord
        },

      };
      this.clickSearch = true;
      this.loading = true;
      this.data = [];
      let search = this.keyWord.join(',');
      let data = { name: search };
      await Promise.all([
        request({
          url: '/kpSeed/list',
          method: 'post',
          data
        }).then(res => {
          if (res.code === 200) {
            res.data.forEach(item => {
              this.data.unshift({...item, origin: 'seed-KP池'});
            });
          }
        }).catch(err => {
          console.log(err);
        }),
        queryByName(search).then(res => {
          if (res.code === 200) {
            res.data.forEach(item => {
              this.data.push({
                name: item.userName,
                info: item.info,
                director: item.contacts,
                origin: item.origin
              });
            });
          }
        }).catch(err => {
          console.log(err);
        })
      ]).finally(() => {
        this.loading = false;
        this.data.forEach(i => {
          if(event[i.origin]) {
            event.tags[i.origin] += 1;
          } else {
            event.tags[i.origin] = 1;
          }

        });
        event.fingerprint = Object.keys( event.tags).map(key => event.tags[key]),
        this.$sentry.captureEvent(event);
      });

    },
    clickItem(record) {
      let event = {
        message: '搜索结果点击查看负责人',
        tags: {
          type: 'humint-search-click-item',
          name: record.name,
          origin: record.origin
        },
        fingerprint: [record.name, record.origin]
      };
      this.$sentry.captureEvent(event);
    }
  },
});
</script>

<style lang="less" scoped>
.table-div {
  padding-top: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  .table {
    width: 100%;
  }
}
.xvqiu {
  margin: 15px 0;
}
.feedback-button {
  color: #999;
  margin: 10px 0;
}
/deep/ .ant-table-tbody > tr > td {
  @media only screen and (max-width: 800px) {
    padding: 10px 5px;
  }
}
@media only screen and (max-width: 800px) {
  .container {
    padding: 20px;
    .search-input {
        width: 80%;
      }
    .table-div {
      padding-top: 20px;
    }

    .search-btn {
      margin-left: 12px;
    }
  }
}
@media only screen and (min-width: 800px) {
  .container {
    padding-top: 50px;
    .content {
      justify-content: center;
      .search-input {
        width: 40%;
      }
      .search-btn {
        margin-left: 24px;
      }
    }
    .table-div {
      padding-top: 32px;
    }
  }
}

.flex {
  display: flex;
}
</style>
